<template>
  <div class="p-8">
    <BaseFetchData :action="loadData">
      <template #default="fetchDataProps">
        <div v-if="fetchDataProps.status.resolved">
          <BaseCard>
            <BaseCardBody>
              <div class="space-y-6">
                <fieldset>
                  <legend class="text-base font-medium text-gray-900">
                    {{ $t('contactsBulkMerge.mergeCriteria.label') }}
                  </legend>

                  <div class="mt-4 grid grid-cols-1 gap-y-6 sm:grid-cols-3 sm:gap-x-4">
                    <label
                      v-for="mergeOption in mergeOptions"
                      :key="mergeOption.value"
                      class="relative flex cursor-pointer rounded-lg border bg-white p-4 shadow-sm focus:outline-none"
                      :class="[
                        mergeCriteria === mergeOption.value
                          ? 'border-transparent'
                          : 'border-gray-300',
                      ]"
                    >
                      <input
                        type="radio"
                        name="merge-criteria"
                        v-model="mergeCriteria"
                        :value="mergeOption.value"
                        class="sr-only"
                      />
                      <span class="flex flex-1">
                        <span class="flex flex-col">
                          <span
                            id="project-type-0-label"
                            class="block text-sm font-medium text-gray-900"
                            >{{ $t(mergeOption.label) }}</span
                          >
                          <span
                            id="project-type-0-description-0"
                            class="mt-1 flex items-center text-sm text-gray-500"
                            >{{ $t(mergeOption.description) }}</span
                          >
                          <span
                            id="project-type-0-description-1"
                            class="mt-6 text-sm font-medium text-gray-900"
                            >{{ mergeOption.count }} {{ $t('global.contacts') }}</span
                          >
                        </span>
                      </span>

                      <svg
                        v-show="mergeCriteria === mergeOption.value"
                        class="h-5 w-5 text-indigo-600"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.857-9.809a.75.75 0 00-1.214-.882l-3.483 4.79-1.88-1.88a.75.75 0 10-1.06 1.061l2.5 2.5a.75.75 0 001.137-.089l4-5.5z"
                          clip-rule="evenodd"
                        />
                      </svg>

                      <span
                        class="pointer-events-none absolute -inset-px rounded-lg border"
                        :class="[
                          mergeCriteria === mergeOption.value
                            ? 'border-indigo-500'
                            : 'border-transparent',
                        ]"
                      ></span>
                    </label>
                  </div>
                </fieldset>

                <div class="rounded-md bg-blue-50 p-4">
                  <div class="mt-2 text-sm text-blue-700">
                    <h3 class="text-sm font-medium text-blue-800">
                      {{ $t('contactsBulkMerge.info.title') }}
                    </h3>
                    <ol class="list-decimal list-inside space-y-1 mt-2 max-w-xl">
                      <li>
                        {{ $t('contactsBulkMerge.info.lineA') }}
                      </li>
                      <li>{{ $t('contactsBulkMerge.info.lineB') }}</li>
                      <li>
                        {{ $t('contactsBulkMerge.info.lineC') }}
                      </li>
                    </ol>
                  </div>
                </div>
              </div>
            </BaseCardBody>
            <BaseCardBody>
              <BaseButton primary :disabled="response.pending" @click="beginMerge">{{
                $t('global.merge')
              }}</BaseButton>
            </BaseCardBody>
          </BaseCard>
        </div>
      </template>
    </BaseFetchData>
  </div>
</template>

<script>
import { accountDuplicateContactsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      info: null,
      mergeCriteria: 'email_address',
      response: {
        pending: false,
        data: null,
      },
    };
  },
  computed: {
    mergeOptions() {
      return [
        {
          value: 'email_address',
          label: 'contactsBulkMerge.mergeCriteria.byEmailAddressOption.label',
          description: 'contactsBulkMerge.mergeCriteria.byEmailAddressOption.description',
          count: this.info?.duplicates_by_email_address || 0,
        },
        {
          value: 'phone_number',
          label: 'contactsBulkMerge.mergeCriteria.byPhoneNumberOption.label',
          description: 'contactsBulkMerge.mergeCriteria.byPhoneNumberOption.description',
          count: this.info?.duplicates_by_phone_number || 0,
        },
        {
          value: 'both',
          label: 'contactsBulkMerge.mergeCriteria.byBothOption.label',
          description: 'contactsBulkMerge.mergeCriteria.byBothOption.description',
          count: this.info?.duplicates_by_email_address_and_phone_number || 0,
        },
      ];
    },
  },
  methods: {
    async loadData() {
      try {
        const response = await accountDuplicateContactsClient.scan(this.accountId);
        this.info = response.data;
      } catch (error) {
        //
      }
    },
    async beginMerge() {
      if (this.response.pending) {
        return;
      }

      this.response.pending = true;

      return accountDuplicateContactsClient
        .merge(this.accountId, {
          merge_criteria: this.mergeCriteria,
        })
        .then((response) => {
          this.response.data = response.data;
          this.$emit('bulk-merge-started');
        })
        .catch(() => {
          this.response.pending = false;
        });
    },
  },
};
</script>
